import styles from '../components/css/spinner.module.css';

const Spinner = () => <div className={styles.loader}></div>;

export default Spinner;
